import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _fc1482b2 = () => interopDefault(import('../../../pages/cookieSIP.vue' /* webpackChunkName: "pages/cookieSIP" */))
const _3b516628 = () => interopDefault(import('../../../pages/editor.vue' /* webpackChunkName: "pages/editor" */))
const _6e538433 = () => interopDefault(import('../../../pages/hydra.vue' /* webpackChunkName: "pages/hydra" */))
const _389812ac = () => interopDefault(import('../../../pages/lavora-offerte-lavoro.vue' /* webpackChunkName: "pages/lavora-offerte-lavoro" */))
const _ffa3fdc8 = () => interopDefault(import('../../../pages/note-legali.vue' /* webpackChunkName: "pages/note-legali" */))
const _aeab61ce = () => interopDefault(import('../../../pages/portfolio.vue' /* webpackChunkName: "pages/portfolio" */))
const _b3e0bf42 = () => interopDefault(import('../../../pages/post.vue' /* webpackChunkName: "pages/post" */))
const _000670ce = () => interopDefault(import('../../../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _513098ba = () => interopDefault(import('../../../pages/tec.vue' /* webpackChunkName: "pages/tec" */))
const _77002223 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/cookieSIP",
    component: _fc1482b2,
    name: "cookieSIP"
  }, {
    path: "/editor",
    component: _3b516628,
    name: "editor"
  }, {
    path: "/hydra",
    component: _6e538433,
    name: "hydra"
  }, {
    path: "/lavora-offerte-lavoro",
    component: _389812ac,
    name: "lavora-offerte-lavoro"
  }, {
    path: "/note-legali",
    component: _ffa3fdc8,
    name: "note-legali"
  }, {
    path: "/portfolio",
    component: _aeab61ce,
    name: "portfolio"
  }, {
    path: "/post",
    component: _b3e0bf42,
    name: "post"
  }, {
    path: "/privacy",
    component: _000670ce,
    name: "privacy"
  }, {
    path: "/tec",
    component: _513098ba,
    name: "tec"
  }, {
    path: "/",
    component: _77002223,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
